module.exports = __webpack_public_path__ + "img/step-1-01.af4a0afa.png";